import { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

export const query = graphql`
  query {
    allNodeEvents(sort: {fields: created, order: DESC}) {
      edges {
        node {
          created
          relationships {
            field_event_image {
              relationships {
                field_media_image_1 {
                  gatsbyImage(fit: COVER, formats: AUTO, layout: FULL_WIDTH, quality: 100, width: 380)
                }
              }
            }
          }
          field_event_address {
            address_line1
            address_line2
            administrative_area
            family_name
            country_code
            given_name
            locality
            postal_code
          }
          field_event_date {
            value
            end_value
          }
          path {
            alias
          }
          body {
            value
          }
          title
        }
      }
    }
  }
`

const formatEvents = ({ edges }) => {
  return edges.map(({ node }) => {
    let image = false
    // @todo, handle default / fallback image.
    if (node.relationships.field_event_image) {
      image = node.relationships.field_event_image.relationships.field_media_image_1.gatsbyImage
    }

    return {
      title: node.title,
      body: node.body,
      date: node.field_event_date,
      address: node.field_event_address,
      path: node.path.alias,
      image: image
    }
  })
}

export const useEvents = () => {
  const { allNodeEvents } = useStaticQuery(query)
  return useMemo(() => formatEvents(allNodeEvents), [allNodeEvents])
}
